export const tokens = {
  // Backgrounds & Surfaces
  bg: '#F5F6FA',
  surface: '#FFFFFF',
  card: '#FFFFFF',
  hover: '#F0F1F5',

  // Brand & Accent
  accent: '#D23A3B',
  accentSoft: 'rgba(210,58,59,0.08)',
  accentGlow: 'rgba(210,58,59,0.15)',

  // Semantic
  green: '#16A34A',
  greenSoft: 'rgba(22,163,74,0.08)',
  red: '#DC2626',
  redSoft: 'rgba(220,38,38,0.08)',
  orange: '#D97706',
  orangeSoft: 'rgba(217,119,6,0.08)',

  // Text
  t1: '#1A1D2E',
  t2: '#5A6178',
  t3: '#9CA3B8',

  // Structure
  cardBorder: '#E2E5EC',
  divider: '#E8EAF0',

  // Elevation
  shadow: '0 1px 3px rgba(0,0,0,0.06)',
  cardShadow: '0 1px 4px rgba(0,0,0,0.05)',
  sidebarShadow: '2px 0 8px rgba(0,0,0,0.03)',
  topbarShadow: '0 1px 3px rgba(0,0,0,0.04)',

  // Typography
  fontPrimary: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontMono: "'DM Mono', 'SF Mono', 'Consolas', monospace",

  // Sidebar
  sidebarWidth: 250,
  topBarHeight: 56,

  // Logo gradient
  logoGradient: 'linear-gradient(135deg, #D23A3B, #E86B6B)',
} as const;

export const chartColors = [
  tokens.accent,
  tokens.green,
  tokens.orange,
  'var(--chart-indigo, #6366F1)',
  'var(--chart-pink, #EC4899)',
  'var(--chart-teal, #14B8A6)',
  'var(--chart-amber, #F59E0B)',
  'var(--chart-violet, #8B5CF6)',
];

export type Theme = typeof tokens;
